module.exports = __webpack_public_path__ + "img/5img_page-0001.5e924cec.jpg";